import './App.css';
import React from 'react';
import {
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import { allRoutes } from "./routes";
import error from "./page-blocks/single/error/page404";
import { FloatingSideButtons } from "./page-blocks/common";

const bg_styles = `
  #intro {
    background: linear-gradient(135deg, #002244 0%, #004289 100%);
  }
`
function App() {
  const getComponent = (component) => {
    return React.createElement(component, {});
  };
  return (
    <div className="App">
      <style>{bg_styles}</style>
      <FloatingSideButtons />

      {/* <Routes >
            <Route path={'/'} element={ <Home/> } />
            <Route path={'/page1'} element={ <Component1/> } />
            <Route path={'/page2'} element={ <Component2/> } />
      </Routes > */}

      <Routes>
        {/* start English routes and default routes */}
        <Route path={"/*"} element={getComponent(error)} />
        <Route path={"/"} element={<Navigate replace to={"/en/home"} />} />
        <Route path={"/en"} element={<Navigate replace to={"/en/home"} />} />
        {allRoutes.map((route, index) => (
          <Route
            path={route.path}
            element={<Navigate replace to={"/en" + route.path} />}
          />
        ))}
        {allRoutes.map((route, index) => (
          <Route
            path={"/en" + route.path}
            element={getComponent(route.component)}
          />
        ))}
        {allRoutes.map((route, index) => (
          <Route
            path={"/en" + route.path + "/*"}
            element={getComponent(route.component)}
          />
        ))}
        {/* end English routes and default routes */}

        {/* start Hindi routes */}
        <Route path={"/hi"} element={<Navigate replace to={"/hi/home"} />} />
        {allRoutes.map((route, index) => (
          <Route
            path={"/hi" + route.path}
            element={getComponent(route.component)}
          />
        ))}
        {allRoutes.map((route, index) => (
          <Route
            path={"/hi" + route.path + "/*"}
            element={getComponent(route.component)}
          />
        ))}
        {/* end Hindi routes */}
      </Routes>
    </div>
  );
}

export default App;